class OiHeader {
    private oiHeaderElement: HTMLElement | null
    private bodyElement: HTMLElement | null
    private overlayElement: HTMLElement | null
    private toggleMenu: HTMLElement | null


    constructor(oiHeader: HTMLElement) {
        console.log('OiHeader: Constructor')

        //init elements
        this.oiHeaderElement = oiHeader
        this.bodyElement = document.querySelector('body')
        this.overlayElement = document.querySelector('#js-overlay')
        this.toggleMenu = document.querySelector('#js-toggle-menu')

        this.toggleMenu.addEventListener('click', () => {
            if(this.oiHeaderElement.classList.contains('is-open')) {
                this.oiHeaderElement.classList.remove('is-open')
                this.closeOverlay()
            } else {
                this.oiHeaderElement.classList.add('is-open')
                this.openOverlay()
            }
        })

        const mobileMenuOverlay = this.oiHeaderElement.querySelector('.main-navigation-mobile .home-hero-mask') as HTMLElement;
        const scrollContainer = this.oiHeaderElement.querySelector('.main-navigation-mobile .menu-scroll-container') as HTMLElement;

        if (mobileMenuOverlay) {
            mobileMenuOverlay.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;
                if (target === mobileMenuOverlay || target === scrollContainer) {
                    this.oiHeaderElement.classList.remove('is-open');
                    this.closeOverlay();
                }
            });
        }

        // Open submenu
        this.oiHeaderElement.querySelectorAll('.js-has-submenu').forEach((element) => {
            element.addEventListener('click', (event: Event) => {
                event.preventDefault()
                element.classList.toggle('is-submenu-open')
                const subMenu = element.nextElementSibling as HTMLElement
                if (subMenu && subMenu.classList.contains('js-sub-menu')) {
                    this.oiHeaderElement.querySelectorAll('.js-sub-menu').forEach((element) => {
                        if (!element.classList.contains('hidden')) {
                            element.classList.add('hidden')
                        }
                    })
                    subMenu.classList.remove('hidden')
                    this.oiHeaderElement.classList.add('submenu-open')
                    this.openOverlay()
                }
            });
        })

        this.oiHeaderElement.querySelectorAll('.js-sub-menu').forEach((subMenuElement: HTMLElement) => {
            const subMenuScrollContainer = subMenuElement.querySelector('.menu-scroll-container');

            subMenuElement.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;

                if (target === subMenuElement || target === subMenuScrollContainer) {
                    this.closeSubmenu();
                    this.oiHeaderElement.classList.remove('is-open');
                    this.closeOverlay();
                }
            });
        });

        this.oiHeaderElement.querySelectorAll('.js-close').forEach((element) => {
            element.addEventListener('click', () => {
                console.log("Close")
                this.closeSubmenu()
                this.closeOverlay()
            });
        })

        this.oiHeaderElement.querySelectorAll('.js-back').forEach((element) => {
            element.addEventListener('click', () => {
                console.log("Back")
                this.closeSubmenu();
            });
        })

        this.overlayElement.addEventListener('click', () => {
            this.oiHeaderElement.classList.remove('is-open')
            this.closeSubmenu()
            this.closeOverlay()
        });
    }

    private closeSubmenu() {
        const subMenu = this.oiHeaderElement.querySelectorAll('.js-sub-menu')
        subMenu.forEach((element: HTMLElement) => {
            element.classList.add('hidden');
        });
        this.oiHeaderElement.classList.remove('submenu-open')
    }

    private openOverlay() {
        this.overlayElement.classList.remove('hidden')
        this.bodyElement.classList.add('noscroll')
    }



    private closeOverlay() {
        this.overlayElement.classList.add('hidden')
        this.bodyElement.classList.remove('noscroll')
    }

    private closeMenu() {
        if(this.oiHeaderElement.classList.contains('is-open')) {
            this.oiHeaderElement.classList.remove('is-open')
            this.closeOverlay()
        } else {
            this.oiHeaderElement.classList.add('is-open')
            this.openOverlay()
        }
    }
}


export default OiHeader;